import { RouterProvider } from 'react-router-dom';
import router from './routes/routes';
import { UserDataProvider } from './shared/context/user-data-context';
import { AccessibilityProvider } from './shared/context/a11y-context';
import { I18nProvider } from './shared/i18n/i18n-context';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


function App() {
  return (
    <UserDataProvider>
      <I18nProvider>
        <AccessibilityProvider>
          <RouterProvider router={router} />
        </AccessibilityProvider>
      </I18nProvider>
    </UserDataProvider>
  );
}

export default App;
